var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TextField from "@mui/material/TextField";
import { Autocomplete, Stack } from "@mui/material";
import { CURRENCY_CODE_SYMBOLS, formatCurrencyNameSymbol } from "../utils/currency.util";
var AmountField = function (props) {
    var _a, _b, _c;
    var amountToShow = props.showNetAmount ? (_a = props.value) === null || _a === void 0 ? void 0 : _a.amountBeforeTax : (_b = props.value) === null || _b === void 0 ? void 0 : _b.amount;
    return (_jsxs(Stack, __assign({ direction: 'row', gap: 1, id: props.id, sx: __assign({ width: '100%' }, props.sx) }, { children: [_jsx(TextField, { id: 'amount_value', size: 'small', value: amountToShow || '', onChange: function (e) {
                    var _a, _b, _c, _d;
                    var inputValue = e.target.value;
                    // Allow empty input
                    if (inputValue === '') {
                        if (props.showNetAmount) {
                            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, __assign(__assign({}, props.value), { amountBeforeTaxCents: undefined, amountBeforeTax: undefined }));
                        }
                        else {
                            (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, __assign(__assign({}, props.value), { amountCents: undefined, amount: undefined }));
                        }
                        return;
                    }
                    // Check if input has more than 2 decimal places
                    var decimalIndex = inputValue.indexOf('.');
                    if (decimalIndex !== -1 && inputValue.length - decimalIndex - 1 > 2) {
                        // Truncate to 2 decimal places
                        e.target.value = inputValue.slice(0, decimalIndex + 3);
                        return;
                    }
                    var floatValue = parseFloat(inputValue);
                    if (isNaN(floatValue)) {
                        floatValue = undefined;
                    }
                    var amountCents;
                    var amount = floatValue;
                    if (floatValue !== undefined) {
                        // Round to 2 decimal places
                        amount = Math.round(floatValue * 100) / 100;
                        amountCents = Math.round(floatValue * 100);
                    }
                    if (props.showNetAmount) {
                        (_c = props.onChange) === null || _c === void 0 ? void 0 : _c.call(props, __assign(__assign({}, props.value), { amountBeforeTaxCents: amountCents, amountBeforeTax: amount }));
                    }
                    else {
                        (_d = props.onChange) === null || _d === void 0 ? void 0 : _d.call(props, __assign(__assign({}, props.value), { amountCents: amountCents, amount: amount }));
                    }
                }, fullWidth: true, required: true, type: 'number', disabled: props.disabled, error: props.error && (amountToShow === undefined || amountToShow < 0), label: props.label, inputProps: {
                    step: 0.01
                } }), _jsx(Autocomplete, { id: 'amount_currency', options: __spreadArray([
                    undefined
                ], Object.keys(CURRENCY_CODE_SYMBOLS), true), getOptionLabel: function (option) { return option ? formatCurrencyNameSymbol(option) || '(Not set)' : '(Not set)'; }, value: ((_c = props.value) === null || _c === void 0 ? void 0 : _c.currency) || '', fullWidth: true, onChange: function (e, value) {
                    var _a;
                    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, __assign(__assign({}, props.value), { currency: value || undefined }));
                }, renderInput: function (params) {
                    var _a;
                    return (_jsx(TextField, __assign({}, params, { fullWidth: true, size: 'small', error: props.error && !((_a = props.value) === null || _a === void 0 ? void 0 : _a.currency) })));
                }, disabled: props.disabled, sx: {
                    width: 250
                } })] })));
};
export default AmountField;
